import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

interface DashboardPayload {
  userid?: string;
  daypartid: string | string[];
  fromdate?: string;
  todate?: string;
  siteidlist?: string[];
  searchtext?: string;
  isallsite?: boolean;
}

const initialState: any = {
  dashboardData: [],
  loading: false,
  error: null,
};

export const fetchMenuProjectionDashboard = createAsyncThunk(
  'dashboard/fetchMenuProjectionDashboard',
  async (payload: DashboardPayload) => {
    const response: any = await axiosInstance.post(
      `${BASE_URL}/api/v1/MenuProjection/GetProjectionDashboard`,
      payload
    );
    return response?.data?.data;
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenuProjectionDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuProjectionDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardData = action.payload;
      })
      .addCase(fetchMenuProjectionDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default dashboardSlice.reducer;